import { Component, Input, OnDestroy, Output } from "@angular/core";

@Component({  
  selector: 'sk-double-bounce',
  styles: [`
    .double-bounce-spinner {
      position: relative;
      margin: 25px auto;
      width: 40px;
      height: 40px;
    }
    
    .double-bounce1,
    .double-bounce2 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: #333;
      opacity: 0.6;
    
      -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
      animation: sk-bounce 2.0s infinite ease-in-out;
    }
    
    .double-bounce2 {
      -webkit-animation-delay: -1.0s;
      animation-delay: -1.0s;
    }
    
    @-webkit-keyframes sk-bounce {
      0%, 100% {
        -webkit-transform: scale(0.0)
      }
      50% {
        -webkit-transform: scale(1.0)
      }
    }
    
    @keyframes sk-bounce {
      0%, 100% {
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
      }
      50% {
        transform: scale(1.0);
        -webkit-transform: scale(1.0);
      }
    }
  `],
  template: `
    <div [hidden]="!visible" class="double-bounce-spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  `
})

export class DoubleBounceComponent implements OnDestroy {
  visible: boolean = true;
  private timeout: any;
  
  @Input()
  public delay: number = 0;
  
  @Output()
  public get isVisible(){
    return this.visible;
  }

  @Input()
  public set isRunning(value: boolean) {
    if (!value) {
      this.cancel();
      this.visible = false;
      return;
    }
    
    if (this.timeout) {
      return;
    }
    
    this.timeout = setTimeout(() => {
      this.visible = true;
      this.cancel();
    }, this.delay);
  }
  
  private cancel(): void {
    clearTimeout(this.timeout);
    this.timeout = undefined;
  }
  
  ngOnDestroy(): any {
    this.cancel();
  }
}


// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/shared/spinners/double-bounce/double-bounce.component.ts